import { ColDef } from '@ag-grid-community/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { FormServices } from 'src/app/services/form.services';
import { FormulaServices } from 'src/app/services/formula.service';
import { SnackbarService } from 'src/app/services/snackbar.service';


export interface FormItemConfiguration{
    event?: Function;
    hide?: boolean;
    hideFunction?: Function;
    name:string;
    title:string;
    description:string;
    tooltip:string;
    type:string;
    required?:boolean;
    defaultValue?:any;
    maxLength?:number;
    minLength?:number;
    options?:FormItemConfigurationOption[],
    optionsFiltered?:FormItemConfigurationOption[],
    optionsHideKey?:boolean,
    enableDisableFunction?:Function;
    colDef?:ColDef;
    entityName?:string;
    entityDesc?:string;
    controlName?:string;
    columnName?:string;
    fieldName?:string;
    condition?:string;
    hidePassWord?:boolean;
    onClick?:Function;
}

export interface FormItemSaving{
    index:number;
    form:FormGroup;
    new?:boolean;
}

export interface FormItemRemoving extends FormItemSaving{
  
}

export interface FormItemCanceling extends FormItemSaving{
  
}

export interface FormItemEditData{
    index:number;
    data:Object;
}

export interface FormItemConfigurationOption{
    key:any;
    value:string;
}

@Component({
    selector: 'form-item-component',
    templateUrl: './form-item-component.component.html',
    styleUrls: ['./form-item-component.component.scss'],
    standalone: false
})
export class FormItemComponentComponent implements OnInit, OnChanges {

  @Input()title:string;
  @Input()formulario:FormGroup<any>;
  @Input()formConfiguration:FormItemConfiguration[]
  showSaveButton:boolean = true;
  showCancelButton:boolean = true;
  @Input()editData:FormItemEditData;
  @Output()saving:EventEmitter<FormItemSaving> = new EventEmitter();
  @Output()removing:EventEmitter<FormItemRemoving> = new EventEmitter();
  @Output()canceling:EventEmitter<FormItemCanceling> = new EventEmitter();
  controles:Observable<FormControl[]> = new Observable<FormControl[]>();
  visible = true;
  selectable = true;
  removable = true;

  selectedIndex: number = -1;
  showRemoveButton:boolean = false;
  formItem: FormGroup<{}>;
  sub1: Subscription;
  

  constructor(private formBuilder:FormBuilder,
    private formulaServices:FormulaServices,
    private formServices:FormServices,
    private snackServices:SnackbarService) { }
  
  ngOnDestroy(){
    if ( this.sub1!= null)  {this.sub1.unsubscribe();}
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    
  }

  getChipFormControl(index,name){
    if ( this.formItem.get(name) != null ){
      return this.formItem.get(name) as FormControl;
    }else{
      return null;
    }
  }

  ngOnInit(): void {

    this.addItemObjectItem();
    this.loadEditData();
  }

  loadEditData(){
    
    if ( this.editData!= null && this.editData.index >-1){
      this.formServices.refreshFormObject(this.formItem,this.editData.data,true,false);
    }
    
  }

  getFilteredOption(item:FormItemConfiguration){
    
  }
  
  itemClickSearch(event:MouseEvent){
    event.preventDefault();
    event.stopPropagation();
  }

  addItemObjectItem() {
      if ( this.formulario == null ){
        this.formItem = this.formBuilder.group({});
      }else{
        this.formItem = this.formulario;
      }
      //this.formItem = this.formBuilder.group({});
      
      this.formConfiguration.forEach(data=>{
        
        if ( data.type=='search'){
          this.formItem.addControl(data.controlName, new FormControl<string[]>([]));
          if ( data.required ){
            this.formItem.get(data.controlName).addValidators(Validators.required);
          }

          if ( data.maxLength!= null && data.maxLength > 0 ){
            this.formItem.get(data.controlName).addValidators(Validators.maxLength(data.maxLength));
          }

          if ( data.minLength != null && data.minLength >0 ){
            this.formItem.get(data.controlName).addValidators(Validators.maxLength(data.minLength));
          }
        }else{
          if ( data.type == 'chips'){
            this.formItem.addControl(data.name, new FormControl<string[]>([]));
          }else{
            if ( data.defaultValue != null ){
              this.formItem.addControl(data.name, new FormControl<any>(data.defaultValue));
            }else{
              this.formItem.addControl(data.name, new FormControl<any>(null));
            } 
          }

          if ( data.type=='select'){
            this.formItem.addControl(data.name+"_filtered", new FormControl<any>(null));
            data.optionsFiltered = data.options;

            this.formItem.get(data.name+"_filtered").valueChanges.subscribe((val:string)=>{
                
                let value = val;
                if ( value != null && value !=''){
                  
                  data.optionsFiltered = data.options.filter(d=>{
                
                    if ( String(d.key).toLowerCase().indexOf( String(value).toLowerCase() ) >-1 ||
                         String(d.value).toLowerCase().indexOf( String(value).toLowerCase() ) >-1){
                      return true;
                    }else{
                      return false;
                    }
                  })
                }else{
                  data.optionsFiltered = data.options;
                }
            });
          }
          
          if ( data.required ){
            this.formItem.get(data.name).addValidators(Validators.required);
          }

          if ( data.maxLength!= null && data.maxLength > 0 ){
            this.formItem.get(data.name).addValidators(Validators.maxLength(data.maxLength));
          }

          if ( data.minLength != null && data.minLength >0 ){
            this.formItem.get(data.name).addValidators(Validators.maxLength(data.minLength));
          }

          if ( data.event != null ){
            this.sub1 = this.formItem.get(data.name).valueChanges.subscribe((val)=>{
              data.event.call(data.event,val);
            });
          }
        }

        if ( data.enableDisableFunction != null ){
            this.formItem.valueChanges.subscribe((d:FormGroup)=>{
                let retorno:boolean  = data.enableDisableFunction.call(data.enableDisableFunction,this.formItem);
                if ( retorno ){
                  this.formItem.get(data.name).enable({emitEvent:false,onlySelf:true});
                }else{
                  this.formItem.get(data.name).disable({emitEvent:false,onlySelf:true});
                }
            });
        }

        if ( data.hideFunction != null ){
            this.formItem.valueChanges.subscribe((d:FormGroup)=>{
                let retorno:boolean  = data.hideFunction.call(data.hideFunction,this.formItem);
                this.formConfiguration.find(x=>x.name==data.name).hide = retorno;
            });
          }
          
      });
  }
  
  openFormula(inp, type, formGroup:UntypedFormGroup){
    
    let params:Variable[] = [];
    this.formulaServices.openFormula(inp,params).then(f=>{
        formGroup.get(type).setValue(f);
    });
  }


  selected(i:number){
     this.selectedIndex = i;
  }

  removefilteredFields(){
    Object.keys(this.formItem.controls).forEach(control=>{
        if ( control.endsWith("_filtered")){
            this.formItem.removeControl(control,{emitEvent:false});
        }
    });

      
  }

  save(){
    if( this.editData != null && this.editData.index >-1){
      this.removefilteredFields()

      this.saving.next({index:this.editData.index,form:this.formItem,new:false});
    }else{
      this.saving.next({index:this.editData.index,form:this.formItem,new:true});
    }
  }

  cancel(){
    if ( this.editData != null && this.editData.index>-1 ){
      this.canceling.next({index:this.editData.index,form:this.formItem,new:false});
    }else{
      this.canceling.next({index:this.editData.index,form:this.formItem,new:true}); 
    }
  }

  itemClick(evento:MouseEvent, i:number){
    this.selectedIndex = i;
    evento.stopPropagation();
  }

  // filterOptions(evento,clearAll:boolean,item:FormItemConfiguration){
    
  //   if ( clearAll){
  //       item.optionsFiltered.push(...item.options);
  //   }

  //   if (evento){
  //     item.optionsFiltered = item.options.filter((value)=>{
  //       if (evento == null || value['value']==null){
  //         return false;
  //       }
  //       if ( value['key'].toLowerCase().indexOf( evento.toLowerCase())>-1||
  //            value['value'].toLowerCase().indexOf( evento.toLowerCase())>-1) {
  //         return true;
  //       }else{
  //         return false;
  //       }
  //     });
  //   }else{
  //     item.optionsFiltered= item.options;
  //   }

  // }

}
